<template>
  <div>
    <a-layout-content style="padding: 0 50px;">
      <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">

        <div class="detailed-liner">
          <div class="detailed-unit" :style="{'background-image':'url('+detailedUnitImage[0]+')'}">
          </div>

          <div class="detailed-unit">
            <div class="detailed-text">
              <div class="detailed-title">一键翻新</div>
              <div class="detailed-brif">老照片、模糊照片、网络图片、视频截图</div>
            </div>
          </div>
        </div>
        <div class="detailed-liner">
          <div class="detailed-unit">
            <div class="detailed-text">
              <div class="detailed-title">黑白上色</div>
              <div class="detailed-brif">照片色彩填充，还原你的世界</div>
            </div>
          </div>

          <div class="detailed-unit" :style="{'background-image':'url('+detailedUnitImage[1]+')'}">
          </div>
        </div>
        <div class="detailed-liner">

          <div class="detailed-unit" :style="{'background-image':'url('+detailedUnitImage[2]+')'}">
          </div>

          <div class="detailed-unit">
            <div class="detailed-text">
              <div class="detailed-title">照片优化</div>
              <div class="detailed-brif">无损放大1倍、对比度增强、图像去雾</div>
            </div>
          </div>
        </div>
        <div class="detailed-liner">

          <div class="detailed-unit">
            <div class="detailed-text">
              <div class="detailed-title">照片优化</div>
              <div class="detailed-brif">无损放大1倍、对比度增强、图像去雾</div>
            </div>
          </div>

          <div class="detailed-unit" :style="{'background-image':'url('+detailedUnitImage[3]+')'}">
          </div>

        </div>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import config from "../assets/扫描识字大师/config";

export default {
  name: "layout-content-detailed",
  data: function() {
    return {
      detailedUnitImage: config.DetailedPic
    }
  }
}
</script>

<style scoped>
.detailed-liner{
  width: 100%;
  display: flex;
}
.detailed-unit{
  width: 50%;
  height: 48rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.detailed-text{
  width: 100%;
  height: 9rem;
  position: relative;
  top: 12rem;
}
.detailed-title{
  width: 100%;
  height: 6rem;
  line-height: 6rem;
  font-size: 3rem;
}
.detailed-brif{
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  font-size: 1.5rem;
}
</style>